export default __webpack_public_path__ + "static/media/LandscapeUnselect.f88ba4f6.svg";